import scheduledOrders from './list/reducers'
import importScheduledOrders from './import/reducers'

export default {
  scheduledOrders,
  importScheduledOrders,
}
